import { axios } from '@/Services/Backend';
import { ref } from '@vue/composition-api';

export default function useSocialMedia() {
    const socialMedia = ref([]);

    const getSocialMedia = async (includePropec = true) => {
        return axios
            .get(`/api/get-social-media/${includePropec}`)
            .then((response) => {
                socialMedia.value = response.data.socialMedia;
            })
            .catch((error) => {
                console.log(error);
                socialMedia.value = [];
            });
    };

    return {
        socialMedia,
        getSocialMedia,
    };
}
